import { TBtnElement, TScrollableParentRefType } from './types'

export const getVisiblePortionCenterX = ({
  scrollableParentRef,
  btnElement,
  tooltipRect
}: {
  tooltipRect: DOMRect
  scrollableParentRef: TScrollableParentRefType
  btnElement: TBtnElement
}): number => {
  if (!scrollableParentRef?.current || !btnElement) return 0

  const parent = scrollableParentRef.current

  const parentMetrics = {
    scrollLeft: parent.scrollLeft,
    viewportWidth: parent.clientWidth,
    leftPosition: parent.getBoundingClientRect().left
  }

  const buttonMetrics = {
    leftOffset:
      'offsetLeft' in btnElement
        ? btnElement.offsetLeft
        : btnElement.clientLeft,
    width:
      'offsetWidth' in btnElement
        ? btnElement.offsetWidth
        : btnElement.clientWidth
  }

  const calculateCenterX = (visibleWidth: number, offsetFromLeft: number = 0) =>
    parentMetrics.leftPosition +
    offsetFromLeft +
    visibleWidth / 2 -
    tooltipRect.width / 2

  // Button is scrolled out of view from the left
  if (parentMetrics.scrollLeft > buttonMetrics.leftOffset) {
    const scrolledDistance = parentMetrics.scrollLeft - buttonMetrics.leftOffset
    const visibleWidth = buttonMetrics.width - scrolledDistance

    return calculateCenterX(Math.min(parentMetrics.viewportWidth, visibleWidth))
  }

  // Button is visible or partially scrolled
  const buttonVisibleOffset =
    buttonMetrics.leftOffset - parentMetrics.scrollLeft
  const remainingViewportWidth =
    parentMetrics.viewportWidth - buttonVisibleOffset
  const visibleWidth = Math.min(buttonMetrics.width, remainingViewportWidth)

  return calculateCenterX(visibleWidth, buttonVisibleOffset)
}

export const getButtonCenter = (btnRect: DOMRect) => ({
  x: btnRect.x + btnRect.width / 2,
  y: btnRect.y + btnRect.height / 2
})

export const adaptOffset = (offset: number): number =>
  Math.max(5, Math.min(95, offset))
